import { GlobalAxios } from "./../axios/axios-config";
import { INewIService, IIService } from "../models/i-service";
import { ISelectType } from "@4uhub/lib4uhub";
import { AxiosResponse } from "axios";
import { ISearchReturn } from "../models/requests";
import { IIServiceType } from "../models/i-service-type";
import { iServiceTypeListByAutomation } from "./iServiceType.service";

const I_SERVICE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/IService/";

interface IIServiceListItem extends ISelectType {
  enable: boolean;
  iServiceType: IIServiceType;
}

const emptyIServiceListResponse = (): AxiosResponse<ISelectType[]> =>
  ({
    data: [],
    status: 200,
    statusText: "OK",
    headers: {},
    config: {},
  }) as unknown as AxiosResponse<ISelectType[]>;

export const createIService = (item: INewIService) => {
  return GlobalAxios.post(I_SERVICE_ROUTE, item);
};

export const getIServiceById = (id: string) => {
  return GlobalAxios.get<IIService>(I_SERVICE_ROUTE + id);
};

export const updateIServiceById = ({
  item,
  id,
}: {
  item: INewIService;
  id: string;
}) => {
  return GlobalAxios.put(I_SERVICE_ROUTE + id, item);
};

export const iServiceList = (params: any) => {
  return GlobalAxios.get<ISelectType[]>(I_SERVICE_ROUTE + "list", {
    params,
  });
};

export const iServiceListByAutomation = async (params?: {
  automationId?: string | null;
}) => {
  if (!params?.automationId) {
    return emptyIServiceListResponse();
  }

  const serviceTypesResponse = await iServiceTypeListByAutomation({
    automationId: params.automationId,
  });

  if (!serviceTypesResponse.data.length) {
    return emptyIServiceListResponse();
  }

  const allowedServiceTypeIds = new Set(
    serviceTypesResponse.data.map((serviceType) => serviceType.id),
  );

  const servicesResponse = await GlobalAxios.get<
    ISearchReturn<IIServiceListItem>
  >(I_SERVICE_ROUTE, {
    params: {
      PageNumber: 1,
      PageSize: 1000,
    },
  });

  return {
    ...servicesResponse,
    data: servicesResponse.data.items
      .filter((service) => allowedServiceTypeIds.has(service.iServiceType.id))
      .map(({ id, name, code, description, enable }) => ({
        id,
        name,
        code,
        description,
        enable,
      })),
  } as AxiosResponse<ISelectType[]>;
};
